import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook, Clock } from 'lucide-react';
import { salonInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#3D7A8C] text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About Section */}
          <div>
            <div className="mb-6">
              <img 
                src="/logo-dark.jpeg" 
                alt={salonInfo.name}
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-white/90 mb-4 leading-relaxed">
              {salonInfo.tagline}
            </p>
            <p className="text-white/70 text-sm leading-relaxed">
              Experience premium beauty and wellness services at our salon. Our expert team is dedicated to making you look and feel amazing.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg font-bold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors duration-300 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-white/60 rounded-full"></span>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors duration-300 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-white/60 rounded-full"></span>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/location" className="text-white/80 hover:text-white transition-colors duration-300 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-white/60 rounded-full"></span>
                  Location & Hours
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-serif text-lg font-bold text-white mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${salonInfo.phone}`} className="flex items-start gap-3 text-white/80 hover:text-white transition-colors duration-300 group">
                  <Phone className="w-5 h-5 mt-0.5 text-white/70 group-hover:text-white transition-colors" />
                  <span>{salonInfo.phone}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${salonInfo.email}`} className="flex items-start gap-3 text-white/80 hover:text-white transition-colors duration-300 group">
                  <Mail className="w-5 h-5 mt-0.5 text-white/70 group-hover:text-white transition-colors" />
                  <span className="break-all">{salonInfo.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/80">
                <MapPin className="w-5 h-5 mt-0.5 text-white/70" />
                <span>
                  {salonInfo.address.street}<br />
                  {salonInfo.address.city}, {salonInfo.address.state} {salonInfo.address.zip}
                </span>
              </li>
            </ul>
          </div>

          {/* Hours & Social */}
          <div>
            <h4 className="font-serif text-lg font-bold text-white mb-6 flex items-center gap-2">
              <Clock className="w-5 h-5 text-white/70" />
              Business Hours
            </h4>
            <ul className="space-y-2 mb-8">
              <li className="text-white/80 text-sm">
                <span className="font-semibold text-white">Mon - Sun:</span> 10:00 AM - 8:00 PM
              </li>
            </ul>

            <h4 className="font-serif text-lg font-bold text-white mb-4">Follow Us</h4>
            <div className="flex gap-3">
              <button
                type="button"
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-white" />
              </button>
              <button
                type="button"
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5 text-white" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-white/70 text-sm text-center md:text-left">
              <p className="mb-1">© {currentYear} {salonInfo.brandName}. All rights reserved.</p>
              <p className="text-white/50 text-xs">
                &ldquo;{salonInfo.brandName}&rdquo; is the brand name of {salonInfo.registeredName}
              </p>
            </div>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy-policy" className="text-white/70 hover:text-white transition-colors duration-300">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-white/70 hover:text-white transition-colors duration-300">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
